var THRESHOLD = 150;
export var isDarkColor = function (actionColor) {
    return actionColor ? getBrightness(actionColor) < THRESHOLD : false;
};
var getBrightness = function (color) {
    if (color === void 0) { color = ''; }
    var _a = color.replace('rgb(', '').replace(')', '').split(', ').map(Number), r = _a[0], g = _a[1], b = _a[2];
    return (r * 299 + g * 587 + b * 114) / 1000;
};
//# sourceMappingURL=color.js.map